(() => {
  'use strict';

  if (window.RonniesCollectionFacets) {
    window.RonniesCollectionFacets.initialise();
    return;
  }

  const desktopViewport = window.matchMedia('(min-width: 75rem)');

  const statefulControls = (form) =>
    form
      ? [...form.elements].filter(
          (control) =>
            control instanceof HTMLElement &&
            control.matches('input[name], select[name], textarea[name]')
        )
      : [];

  const controlKey = (control) => {
    const type = control instanceof HTMLInputElement ? control.type : control.tagName.toLowerCase();
    const valueKey = type === 'checkbox' || type === 'radio' ? `:${control.value}` : '';
    return `${type}:${control.name}${valueKey}`;
  };

  const syncFormState = (sourceForm, targetForm) => {
    if (!sourceForm || !targetForm || sourceForm === targetForm) return;

    const sourceControls = new Map(
      statefulControls(sourceForm).map((control) => [controlKey(control), control])
    );

    statefulControls(targetForm).forEach((targetControl) => {
      const sourceControl = sourceControls.get(controlKey(targetControl));
      if (!sourceControl) return;

      if (
        targetControl instanceof HTMLInputElement &&
        (targetControl.type === 'checkbox' || targetControl.type === 'radio')
      ) {
        targetControl.checked = sourceControl.checked;
        return;
      }

      targetControl.value = sourceControl.value;
    });
  };

  const syncBodyLock = () => {
    const hasOpenDrawer = Boolean(document.querySelector('[data-rv-facets-drawer][open]'));
    document.body.classList.toggle('rv-facets-drawer-open', hasOpenDrawer);
  };

  const initialiseDrawer = (dialog) => {
    if (dialog.dataset.rvFacetsReady === 'true' || typeof dialog.showModal !== 'function') return;

    const section = dialog.closest('.rv-collection');
    const trigger = [...(section?.querySelectorAll('[data-rv-facets-open]') || [])].find(
      (button) => button.getAttribute('aria-controls') === dialog.id
    );
    const closeButton = dialog.querySelector('[data-rv-facets-close]');
    const form = dialog.querySelector('form');
    const desktopForm = section?.querySelector('[data-rv-facets-form="desktop"]');
    if (!section || !trigger || !closeButton || !form || !desktopForm) return;

    let restoreFocus = true;

    const updateSelectedCount = (sourceForm = form) => {
      const listCount = sourceForm.querySelectorAll('input[type="checkbox"]:checked').length;
      const priceCount = [...sourceForm.querySelectorAll('.rv-facet__price')].filter((group) =>
        [...group.querySelectorAll('input')].some((input) => input.value.trim() !== '')
      ).length;
      const selectedCount = listCount + priceCount;
      const description = `${selectedCount} selected ${selectedCount === 1 ? 'filter' : 'filters'}`;
      const badge = trigger.querySelector('[data-rv-facets-count]');
      const triggerStatus = trigger.querySelector('[data-rv-facets-trigger-status]');
      const drawerStatus = dialog.querySelector('[data-rv-facets-status]');

      if (badge) {
        badge.textContent = String(selectedCount);
        badge.hidden = selectedCount === 0;
      }
      if (triggerStatus) triggerStatus.textContent = `${description}.`;
      if (drawerStatus) drawerStatus.textContent = description;
    };

    const openDrawer = () => {
      if (dialog.open || desktopViewport.matches) return;
      syncFormState(desktopForm, form);
      updateSelectedCount(form);
      restoreFocus = true;
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      syncBodyLock();
      window.requestAnimationFrame(() => closeButton.focus());
    };

    const closeDrawer = (shouldRestoreFocus = true) => {
      if (!dialog.open) return;
      restoreFocus = shouldRestoreFocus;
      dialog.close();
    };

    trigger.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', () => closeDrawer());

    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      syncBodyLock();
      if (restoreFocus && document.contains(trigger)) trigger.focus();
      restoreFocus = true;
    });

    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      const clickedOutside =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;
      if (clickedOutside) closeDrawer();
    });

    form.addEventListener('submit', () => {
      restoreFocus = false;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('rv-facets-drawer-open');
    });

    const syncFromMobile = () => {
      syncFormState(form, desktopForm);
      updateSelectedCount(form);
    };
    const syncFromDesktop = () => {
      syncFormState(desktopForm, form);
      updateSelectedCount(desktopForm);
    };

    form.addEventListener('change', syncFromMobile);
    form.addEventListener('input', syncFromMobile);
    desktopForm.addEventListener('change', syncFromDesktop);
    desktopForm.addEventListener('input', syncFromDesktop);

    form.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => {
        restoreFocus = false;
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('rv-facets-drawer-open');
      });
    });

    const handleViewportChange = (event) => {
      if (event.matches) {
        syncFormState(form, desktopForm);
        updateSelectedCount(desktopForm);
        closeDrawer(false);
      } else {
        syncFormState(desktopForm, form);
        updateSelectedCount(form);
      }
    };

    if (typeof desktopViewport.addEventListener === 'function') {
      desktopViewport.addEventListener('change', handleViewportChange);
    } else {
      desktopViewport.addListener(handleViewportChange);
    }

    section.classList.add('rv-facets-enhanced');
    updateSelectedCount();
    dialog.dataset.rvFacetsReady = 'true';
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-rv-facets-drawer]').forEach(initialiseDrawer);
  };

  window.RonniesCollectionFacets = { initialise };
  initialise();

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', syncBodyLock);
})();
